export type FileAttachmentRef = {
  title?: string;
  type?: string;
};

export type FileKind =
  | "pdf"
  | "image"
  | "spreadsheet"
  | "document"
  | "presentation"
  | "archive"
  | "file";

export const getFileKind = (file: FileAttachmentRef): FileKind => {
  const type = file.type?.toLowerCase() ?? "";
  const name = file.title?.toLowerCase() ?? "";

  if (
    type.startsWith("image/") ||
    /\.(png|jpe?g|gif|webp|svg|bmp)$/i.test(name)
  ) {
    return "image";
  }
  if (type.includes("pdf") || name.endsWith(".pdf")) return "pdf";
  if (
    type.includes("presentation") ||
    type.includes("powerpoint") ||
    /\.(pptx?|key)$/i.test(name)
  ) {
    return "presentation";
  }
  if (
    type.includes("spreadsheet") ||
    type.includes("excel") ||
    /\.(xlsx?|csv|ods)$/i.test(name)
  ) {
    return "spreadsheet";
  }
  if (
    type.includes("word") ||
    type.includes("msword") ||
    /\.(docx?|rtf|odt)$/i.test(name)
  ) {
    return "document";
  }
  if (type.includes("text") || name.endsWith(".txt")) {
    return "document";
  }
  if (
    type.includes("zip") ||
    type.includes("compressed") ||
    /\.(zip|rar|7z|tar|gz)$/i.test(name)
  ) {
    return "archive";
  }
  return "file";
};

/** Outlook-style type badges (Word / Excel / PDF / PowerPoint). */
export const FILE_KIND_BADGE: Record<
  FileKind,
  { label: string; className: string }
> = {
  pdf: { label: "PDF", className: "bg-[#E5252A] text-white" },
  document: { label: "W", className: "bg-[#2B579A] text-white" },
  spreadsheet: { label: "X", className: "bg-[#217346] text-white" },
  presentation: { label: "P", className: "bg-[#C43E1C] text-white" },
  image: { label: "IMG", className: "bg-info text-white" },
  archive: { label: "ZIP", className: "bg-warning text-warning-foreground" },
  file: { label: "FILE", className: "bg-neutral-500 text-white" },
};
